// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ScenarioDiagram_wrapper__yKNP5","pane":"ScenarioDiagram_pane__L5v4L"};